export function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// URS-F339: devuelve el color de texto que mejor contrasta con el fondo
// (`hex`). Usa la luminancia YIQ del W3C. Devuelve un negro suave (#111)
// para fondos claros (luminancia >= 150) y blanco (#fff) para oscuros.
// El umbral 150 se eleva un poco sobre 128 para que amarillos/lima/beige
// reciban texto oscuro.
export function pickTextColor(hex) {
  const h = (hex || '').replace('#', '');
  if (h.length < 6) return '#fff';
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return '#fff';
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 150 ? '#111' : '#fff';
}

export const apptStatusColors = {
  citada: { bg: 'bg-blue-100', text: 'text-blue-800', border: 'border-blue-300' },
  anulada: { bg: 'bg-stone-100', text: 'text-stone-500', border: 'border-stone-300' },
  no_asiste: { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300' },
  sala_espera: { bg: 'bg-amber-100', text: 'text-amber-800', border: 'border-amber-300' },
  especialista: { bg: 'bg-purple-100', text: 'text-purple-800', border: 'border-purple-300' },
  sondas: { bg: 'bg-teal-100', text: 'text-teal-800', border: 'border-teal-300' },
  terminada: { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-300' },
};

export const VIEWS = { day: 'day', week: 'week', month: 'month', schedule: 'schedule' };

export const TIME_SLOTS = [];
for (let h = 8; h <= 20; h++) {
  for (let m = 0; m < 60; m += 15) {
    TIME_SLOTS.push({ h, m, label: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}` });
  }
}
TIME_SLOTS.push({ h: 21, m: 0, label: '21:00' });

export const CELL_HEIGHT = 28;

// --- Day view 5-minute cadence -------------------------------------------
// The general TIME_SLOTS (15-min) keep driving Week / Month views (changing
// them would generate hundreds of rows per day). The Day view requested by
// the user uses a denser, 5-min cadence with a smaller row height.
export const DAY_SLOT_MINUTES = 5;
export const DAY_CELL_HEIGHT = 18; // px per 5-min slot -> 60 min = 216 px
export const DAY_TIME_SLOTS = [];
for (let h = 8; h <= 20; h += 1) {
  for (let m = 0; m < 60; m += DAY_SLOT_MINUTES) {
    DAY_TIME_SLOTS.push({ h, m, label: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}` });
  }
}
DAY_TIME_SLOTS.push({ h: 21, m: 0, label: '21:00' });

export function timeToMinutesFrom8(t) {
  if (!t) return 0;
  const [h, m] = t.split(':').map(Number);
  return (h - 8) * 60 + m;
}

export function pad(n) { return String(n).padStart(2, '0'); }
export function fmtDate(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }
export function addDays(d, n) { const r = new Date(d); r.setDate(r.getDate() + n); return r; }
export function startOfWeek(d) { const r = new Date(d); const day = r.getDay(); r.setDate(r.getDate() - (day === 0 ? 6 : day - 1)); return r; }
export function getDaysInMonth(y, m) { return new Date(y, m + 1, 0).getDate(); }

export const WEEKDAYS_ES = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];
export const WEEKDAYS_EN = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const MONTHS_ES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
